const BASE_COLORS = [
  '#EF4444',
  '#D82BFF',
  '#EA8D0A',
  '#78F793',
  '#2DA265',
  '#7097F8',
  '#3B82F6',
  '#8B5CF6'
];

export const getDeterministicColor = (initials: string) => {
  const hash = initials
    .split("")
    .reduce((acc, char, i) => acc * 31 + char.charCodeAt(0) * (i + 1), 0);

  const baseColorIndex = Math.abs(hash) % BASE_COLORS.length;
  const baseColor = BASE_COLORS[baseColorIndex];

  // Get RGB of base color
  let r = parseInt(baseColor.slice(1, 3), 16);
  let g = parseInt(baseColor.slice(3, 5), 16);
  let b = parseInt(baseColor.slice(5, 7), 16);

  // Use additional bits of hash to drift the color
  const drift = 30; // Max amount to drift by
  r = Math.min(255, Math.max(0, r + ((hash >> 8) % drift) - (drift / 2)));
  g = Math.min(255, Math.max(0, g + ((hash >> 16) % drift) - (drift / 2)));
  b = Math.min(255, Math.max(0, b + ((hash >> 24) % drift) - (drift / 2)));

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  if (luminance > 0.6) {
    const darkenAmount = 0.3;
    r = Math.floor(r * (1 - darkenAmount));
    g = Math.floor(g * (1 - darkenAmount));
    b = Math.floor(b * (1 - darkenAmount));
  }

  return `#${Math.round(r).toString(16).padStart(2, '0')}${Math.round(g).toString(16).padStart(2, '0')}${Math.round(b).toString(16).padStart(2, '0')}`;
};